import React from 'react';
import { toast } from 'react-toastify';
import FormatUrl from '../../utils/UrlFormatter';
import './managePaymentsStyles.css';

const SavedCardDisplay = ({ user, cardList, loading, onCardRemoved }) => {
  const handleRemoveCard = async (paymentProfileId) => {
    try {
      const csrfRes = await fetch(FormatUrl('/csrf-token/'), {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
      });

      const { csrfToken } = await csrfRes.json();

      const payload = {
        profile_id: user?.profile_id,
        payment_profile_id: paymentProfileId,
      };

      const res = await fetch(FormatUrl('/payments/remove-payment-card/'), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': csrfToken,
        },
        credentials: 'include',
        body: JSON.stringify(payload),
      });

      const result = await res.json();

      if (!res.ok) {
        throw new Error(result.error || 'Failed to remove card');
      }

      toast.success('Card removed successfully');
      onCardRemoved?.(); // Optional chaining to avoid runtime error if not passed
    } catch (err) {
      console.error('Error removing card:', err);
      toast.error(err.message || 'Failed to remove card');
    }
  };

  return (
    <div className="saved-card-box">
      {loading ? (
        <div className="card-spinner-wrapper">
          <div className="card-loading-spinner"></div>
        </div>
      ) : cardList.length > 0 ? (
        <div className="saved-card-list">
          {cardList.map((card, index) => (
            <div key={index} className="saved-card-details">
              <div className="card-icon">💳</div>
              <div className="card-details-text">
                <p className="card-brand">
                  <strong>{card.brand?.toUpperCase()}</strong> ending in{' '}
                  <strong>**** {card.last4}</strong>
                </p>
                <p className="card-expiry">
                  Expires {card.exp_month}/{card.exp_year}
                </p>
              </div>

              {/* 🔒 Hide Remove if it's the only card */}
              {cardList.length > 1 && (
                <button
                  className="remove-card-btn"
                  onClick={() => handleRemoveCard(card.payment_profile_id)}
                >
                  Remove
                </button>
              )}
            </div>
          ))}
        </div>
      ) : (
        <p className="placeholder-message">
          You have not saved any card yet. Once you add a card, it will appear here for future use.
        </p>
      )}
    </div>
  );
};

export default SavedCardDisplay;
